// ============================================================
// Datei: src/components/modals/ConfirmJoinShiftModal.jsx
// PURPOSE:
// Bestätigungsdialog zum Übernehmen einer Schicht
// ============================================================

import React from "react";
import "../../styles/confirmModal.css";

const ConfirmJoinShiftModal = ({ onConfirm, onCancel, shift }) => {
    return (
        <div className="confirm-modal-backdrop">
            <div className="confirm-modal">

                <h3>Bestätigung</h3>

                <p>
                    Möchtest du dich wirklich für diese Schicht einschreiben?
                    <br />
                    <strong>
                        {shift?.department} · {shift?.dayOfDeployment}
                        <br />
                        {shift?.startTime} – {shift?.endTime}
                    </strong>
                </p>

                <div className="confirm-modal-actions">
                    <button className="btn-cancel" onClick={onCancel}>
                        Abbrechen
                    </button>

                    <button className="btn-confirm" onClick={onConfirm}>
                        Einschreiben
                    </button>
                </div>

            </div>
        </div>
    );
};

export default ConfirmJoinShiftModal;
